export const ATS_PUBLIC_CANDIDATE_FORM = 'ATS_PUBLIC_CANDIDATE_FORM';
